import React from 'react';

const Closed = ({ followup }) => {
  return (
    <div className="survey-followup-stats_diagrams survey-diagrams -has-bar-values">
      {
        followup.total > 0 &&
        <>
          <div className="survey-diagrams_item survey-diagram">
            <div className="survey-diagram_bar-wrapper">
              <div className="survey-diagram_bar" style={ { height: `${followup.result['1'] || 0}%` } } >
                <div className="survey-diagram_bar-value">
                  { followup.result['1'] || 0 }%
                </div>
              </div>
            </div>
            <div className="survey-diagram_title">Definitely Not</div>
          </div>
          <div className="survey-diagrams_item survey-diagram">
            <div className="survey-diagram_bar-wrapper">
              <div className="survey-diagram_bar" style={ { height: `${followup.result['2'] || 0}%` } } >
                <div className="survey-diagram_bar-value">
                  { followup.result['2'] || 0 }%
                </div>
              </div>
            </div>
            <div className="survey-diagram_title">Probably</div>
          </div>
          <div className="survey-diagrams_item survey-diagram">
            <div className="survey-diagram_bar-wrapper">
              <div className="survey-diagram_bar" style={ { height: `${followup.result['3'] || 0}%` } } >
                <div className="survey-diagram_bar-value">
                  { followup.result['3'] || 0 }%
                </div>
              </div>
            </div>
            <div className="survey-diagram_title">Might</div>
          </div>
          <div className="survey-diagrams_item survey-diagram">
            <div className="survey-diagram_bar-wrapper">
              <div className="survey-diagram_bar" style={ { height: `${followup.result['4'] || 0}%` } } >
                <div className="survey-diagram_bar-value">
                  { followup.result['4'] || 0 }%
                </div>
              </div>
            </div>
            <div className="survey-diagram_title">Probably Would</div>
          </div>
          <div className="survey-diagrams_item survey-diagram">
            <div className="survey-diagram_bar-wrapper">
              <div className="survey-diagram_bar" style={ { height: `${followup.result['5'] || 0}%` } } >
                <div className="survey-diagram_bar-value">
                  { followup.result['5'] || 0 }%
                </div>
              </div>
            </div>
            <div className="survey-diagram_title">Definitely Would</div>
          </div>

        </>
      }
      {
        !followup.total &&
        <div className="survey-diagrams_no-answers-message">
          No answers yet
        </div>
      }
    </div>
  );
};

export default Closed;
